


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Auth from '@aws-amplify/auth';

@Component
export default class ResetPassword extends Vue {

  public step: number = 1;
  public error: string = '';
  public sentTo: string = '';
  public username: string = '';
  public code: string = '';
  public newPassword: string = '';
  public showPassword: boolean = false;
  public currentyear: number = new Date().getFullYear();

  public step1() {
    this.error = '';
    this.sentTo = '';
    Auth.forgotPassword(this.username)
      .then((data: any) => {
        this.sentTo = data.CodeDeliveryDetails.Destination;
        this.step = 2;
      })
      .catch((err: any) => this.$onecentral.displayError(err));
  }

  public step2() {
    Auth.forgotPasswordSubmit(this.username, this.code, this.newPassword)
      .then((data: any) => {
        this.step = 1;
        this.username = '';
        this.code = '';
        this.newPassword = '';
        this.$toasted.success('Password reset');
        this.signIn();
      })
      .catch((err: any) => this.$onecentral.displayError(err));
  }

  public signIn() {
    this.$router.push({ name: 'sign-in' });
  }
  public toggleShow() {
    this.showPassword = !this.showPassword;
  }
}
